export default () => {
    return {
        payload: null
    }
}
